import Vue from 'vue'
import VueAnalytics from 'vue-analytics';
import App from './App.vue'
import router from './router'

Vue.use(VueAnalytics, {
  id: 'GTM-WB5BXV9',
  router
});

window.dataLayer = window.dataLayer || [];

// router.afterEach((to) => {
//   window.dataLayer.push({
//     event: 'pageview',
//     page: to.fullPath
//   });
// });

import { store } from './store'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueResource from 'vue-resource'
Vue.use(VueResource);

import Scrollspy from 'vue2-scrollspy';
Vue.use(Scrollspy);

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);

import VideoBg from 'vue-videobg'
Vue.component('video-bg', VideoBg)

import videojsseekbuttons from 'videojs-seek-buttons';
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('videojsseekbuttons', videojsseekbuttons)

import Vue2TouchEvents from 'vue2-touch-events' 
Vue.use(Vue2TouchEvents)

import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

import PubNubVue from 'pubnub-vue'
const publish_Key = 'pub-c-14a02afa-bacc-4d72-8bdd-daad9666a066';
const subscribe_Key = 'sub-c-caf179f8-d7f7-11eb-85aa-fa77d5b6609d';
// Make a unique uuid for each client
/*const myUuid = fourCharID();
const me = {
  uuid: myUuid,
};
*/

Vue.use(PubNubVue, {
    subscribeKey: subscribe_Key,
    publishKey: publish_Key,
    ssl: false
}, store);

/*
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})
*/

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.config.productionTip = false
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
//import 'vue-material/dist/theme/default-dark.css'
Vue.use(VueMaterial)
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import 'bootstrap/dist/css/bootstrap.css'
import './app.scss'

Vue.mixin({
    computed: {
        get_me(){
        return this.$store.user;
        }
    },

    methods: {
        parse_time(str){
            var d=new Date(str); return (d.getHours() < 10 ? '0' + d.getHours() :d.getHours() ) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() :d.getMinutes() ) ;
        },
        isNull: function (str){
            return (str == '' || str == null || str == undefined);
        },
        api_call: function(settings){
            if (this.isNull(settings.onComplete)){
                settings.onComplete = function(){};
            }else{
                var real_func = settings.onComplete;
                settings.onComplete = function(data){
                    real_func(data);
                };
            }
            if (this.isNull(settings.data)) settings.data = {};
            settings.data.api_user_token = localStorage.getItem('user_token');
            // if (settings.data.api_user_token == '' || this.isNull(settings.data.api_user_token) && this.isNull(localStorage.getItem('user_token')) ){
            //     if (this.$cookies.get('adfasdf')){
            //         alert(4);
            //     }
            // }
            //return this.$http.post(window.api_url + settings.url + '?&ts=' + (new Date()).getHours() + '_' + ((new Date()).getMinutes() < 30 ? '0' : '30') , settings.data).then(settings.onComplete);
            return this.$http.post(window.api_url + settings.url , settings.data).then(settings.onComplete);
        },
        is_mobile: function(){ 
            return ( 
                navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/webOS/i)
                || navigator.userAgent.match(/iPhone/i)
                // || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/BlackBerry/i)
            );
        },
        add_to_fav(id){
            if (!this.get_me || !this.get_me.id) {
                this.$store.commit('open_signup', { step: 1, plan_id: 0 });
                return;
            }

            var userToken = localStorage.getItem('user_token');
            if (this.isNull(userToken)) {
                this.$store.commit('open_signup', { step: 1, plan_id: 0 });
                return;
            }

            var self = this;
            var settings = { 
                item_id: id, 
                api_user_token: userToken
            };
            this.$http.post(window.api_url + 'user/add_favorite', settings)
            .then(function(/*data*/){
                self.$alert('הסרט נוסף לרשימת הצפייה שלך');
            });
        },
        remove_from_fav(id){
            if (!this.get_me || !this.get_me.id) {
                this.$store.commit('open_signup', { step: 1, plan_id: 0 });
                return;
            }

            var userToken = localStorage.getItem('user_token');
            if (this.isNull(userToken)) {
                this.$store.commit('open_signup', { step: 1, plan_id: 0 });
                return;
            }

            var self = this;
            var settings = { 
                item_id: id, 
                api_user_token: userToken
            };
            this.$http.post(window.api_url + 'user/remove_favorite', settings)
            .then(function(/*data*/){
                self.$alert('הסרט הוסר מרשימת הצפייה שלך');
            });
        },
    }
})
  

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


// Listen for route changes and send page view to GTM
router.afterEach((to) => {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'pageview',
            page: {
                url: window.location.href,
                path: to.path,
                name: to.name, // Optional: If you have named routes
            }
        });
    }
});